<div [formGroup]="group" class="u-padding-bottom-half">
    <smvd-ui-score-input
        [id]="question.id"
        [hasMargin]="false"
        [hasMarginDouble]="true"
        [formControlName]="'value'"
        [label]="question | questionTitle"
        [groups]="question.groups"
    ></smvd-ui-score-input>
</div>
